module.exports = __webpack_public_path__ + "adc44f36ffb0d8198993e7429fcc41a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/fotl-l3930r-white.jpg
// module id = 830
// module chunks = 0